
<template>
  <cube-slider
    value="{{ 30 }}"
    custom-content="{{true}}"
    bindchange="handleChange"
    bindchanging="handleChanging"
  >
    <view class="slider-thumb">
      <view class="box"></view>
    </view>
  </cube-slider>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    data: {
      currentValue: 0
    },
    methods: {
      handleChange(e) {
        this.currentValue = e.detail.value
        console.log('change', this.currentValue)
      },
      handleChanging(e) {
        this.currentValue = e.detail.value
        console.log('changing', this.currentValue)
      }
    }
  })
</script>

<style lang="stylus">
.slider-thumb
  position relative
  width: 100%
  height: 100%
  background-image: url("https://gift-pypu-cdn.didistatic.com/static/driver_miniprogram/do1_E57CMf3cLCRJiq2VxPuT")
  background-size: contain
  background-repeat: no-repeat
  background-position: 0 6px
.box
  position absolute
  left 50%
  height 28px
  width 28px
  transform translateX(-50%)
  padding-left 100px
  padding-right 100px
  background-color pink
  opacity 0.3
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-slider": "@mpxjs/mpx-cube-ui/src/components/slider/index.mpx"
    }
  }
</script>
